import { ProductMessage, Message } from '../../../PdpProductProvider/types';
import { parseProductMessage } from './parseProductMessage';

export const getProductMessages = (
  messages?: Array<Message>,
  isHideAwaitingStock?: boolean,
  isAwaitingStock?: boolean,
  isPreOrder?: boolean
): Array<ProductMessage> => {
  const filteredMessages: Array<Message> = [];
  messages?.forEach(message => {
    if (message.type === 'Services' || message.type === 'SpecialOffers') return null;

    if (message.subType === 'Important' && isHideAwaitingStock) {
      if (!isAwaitingStock && !isPreOrder) {
        filteredMessages.unshift(message);
      }
      return;
    }

    filteredMessages.push(message);
  });
  return filteredMessages.map(message => parseProductMessage(message)).filter(m => !!m.content);
};
